//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'PrivacyPolicy',
  components: {},
  head() {
    return {
      title: 'STEP1NE 隱私政策 - 保護您的個人資訊',
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: 'STEP1NE 隱私政策 - 保護您的個人資訊',
        },
        {
          hid: 'description',
          name: 'description',
          content:
            'STEP1NE尊重並保護用戶隱私。本隱私政策說明了我們如何處理個人資訊，包括收集、使用和披露的條件。',
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content:
            'STEP1NE尊重並保護用戶隱私。本隱私政策說明了我們如何處理個人資訊，包括收集、使用和披露的條件。',
        },
      ],
    };
  },
};
